import { Environment } from '@spaces-ui/environment';

export const environment: Environment = {
  stytchPublicToken: 'public-token-test-f30c7c02-30b5-47fd-aad7-b068b461cd98',
  oAuthClientId: 'fa595c38db5440c7b46a2a59049aa2b5',
  ldClientId: '67e3080bedae8b09a64eb871',
  productName: 'Spaces Dev',
  giphyApiKey: 'ESI8D5fTYPDTcRmwafVTiPIlmHO9bm3N',
  streamApiKey: 'v9mcrtd5f3qs',
  uri: {
    webSocket: 'wss://spaces-websocket-api.dev.chat.space',
    blueWebSocket: 'wss://blue-spaces-websocket-api.dev.chat.space',
    stytchApi: 'https://test.stytch.com',
    apiBase: 'https://meadow.dev.chat.space/',
    blueApiBase: 'https://meadow.dev.chat.space/',
    electronProtocol: 'spacesdev',
    appDownload: 'https://dev.chat.space/downloads',
    blueAppDownload: 'https://blue.dev.chat.space/downloads',
  },
  isProduction: false,
};
